<div class="sdps-p-horizontal_medium">
  <sdps-notification type="information" class="sdps-m-top_none" *ngIf="showClientMsg">
    <p class="sdps-notification__text" [innerHTML]="getShellConstant.noCientSelected"></p>
  </sdps-notification>
</div>

<div class="sdps-p-horizontal_medium" *ngIf="!showClientMsg">
  <div class="full-width">
    <form [formGroup]="reportDetails">
      <div class="sdps-grid-container sdps-wrap report-dropdown">

        <div class="sdps-row sdps-p-top_large">
          <span class="sdps-m-right_small">
            <p-radioButton class="emtr-radio ems-inline" inputId="snapShot" name="selectedButtonType" formControlName="selectedButtonType"
              value="{{getShellConstant.reports.RulesDetails.snapShot}}" (ngModelChange)="editSnapshotHistory(true)"></p-radioButton>
              <label class="sdps-p-left_x-small" for="snapShot">{{getShellConstant.reports.RulesDetails.snapShot}}</label>
          </span>

          <span *ngIf="batchCitiOrg !== orgID">
            <p-radioButton class="emtr-radio ems-inline" inputId="history" name="selectedButtonType" formControlName="selectedButtonType"
              value="{{getShellConstant.reports.RulesDetails.historyTxt}}" (ngModelChange)="editSnapshotHistory(true)"></p-radioButton>
              <label class="sdps-p-left_x-small" for="history">{{getShellConstant.reports.RulesDetails.historyTxt}}</label>
          </span>
        </div>

        <div class="sdps-row sdps-p-top_x-large" *ngIf="!snapshotSelected">
          <div class="display-flex">
            <app-report-from-to-datepicker (calendarValidation)="calendarValidation($event)" [dateRange]="90" [initialDateRange]="7" (getEmittedVal)="setDate($event)"
              [calendarForm]="reportDetails" (throwDateError)="throwDateError($event)" (throwDateRangeError)="throwDateRangeError($event)"></app-report-from-to-datepicker>
          </div>
        </div>

        <div class="sdps-row sdps-p-top_large select-report-type" *ngIf="!snapshotSelected">
          <div class="col-3 sdps-p-left_none" *ngIf="businessUnit !== sharedConstant.rbsBUText">
            <div class="report-textbox-border" [ngClass]="{'invalidField': (reportDetails.get('employeeID').value && reportDetails.get('employeeID').invalid)}">
              <p-float-label variant="in">
                <input type="text" id="employeeID" name="employeeID" formControlName="employeeID" [maxLength]="35" emsEmployeeIdPatterncheck emsCharacterLimit
                  [charMaxLimit]="getCommConst.charLimitValues.thirtyFiveMaxLimit" (emsCharacterLimitCheck)="showEmpIdCharLimit = $event" [uppercaseRequired]="true"
                  pInputText/>
                  <label for="employeeID" [innerHTML]="sharedConstant[businessUnit].empOrParticipantsID"></label>
              </p-float-label>
            </div>
            <p class="col-6 sdps-text-right sdps-p-around_none sdps-m-around_none sdps-text-small" *ngIf="reportDetails.get('employeeID').value && reportDetails.get('employeeID').value.length > showEmpIdCharLimit">{{getShellConstant.reports.characterLimit}}
              <span class="character-limit">{{reportDetails.get('employeeID').value.length}} /{{getCommConst.charLimitValues.thirtyFiveMaxLimit}}
              </span>
            </p>
          </div>
          <div class="col-3 sdps-p-left_none">
            <div class="report-textbox-border" [ngClass]="{'invalidField': (reportDetails.get('employeeAccount').value && (reportDetails.get('employeeAccount').invalid || reportDetails.get('employeeAccount').value.length <= 8))}">
              <p-float-label variant="in">
                <input type="text" id="employeeAccount" name="employeeAccount" [maxlength]="10" onkeypress="if(event.which<48 || event.which>57) return false;" emsAccountNumberFormat formControlName="employeeAccount" pInputText/>
                <label for="employeeAccount" [innerHTML]="getShellConstant.reports.presetReports.accountNumber"></label>
              </p-float-label>
            </div>
          </div>
          <div class="col-3 sdps-p-left_none">
            <div class="report-textbox-border" [ngClass]="{'invalidField': (reportDetails.get('employeeLastName').value && reportDetails.get('employeeLastName').invalid)}">
              <p-float-label variant="in">
                <input type="text" id="employeeLastName" *ngIf="businessUnit === sharedConstant.rbsBUText" name="employeeLastName" [maxLength]="30" formControlName="employeeLastName" emsNamePatternCheck emsCharacterLimit
                  (emsCharacterLimitCheck)="showTextboxCharLimit = $event" [charMaxLimit]="getCommConst.charLimitValues.thirtyMaxLimit"
                  pInputText/>
                <input type="text" id="employeeLastName" *ngIf="businessUnit !== sharedConstant.rbsBUText" name="employeeLastName" [maxLength]="30" formControlName="employeeLastName" emsCharacterLimit
                  (emsCharacterLimitCheck)="showTextboxCharLimit = $event" [charMaxLimit]="getCommConst.charLimitValues.thirtyMaxLimit" [uppercaseRequired]="true"
                  pInputText/>
                  <label for="employeeLastName" [innerHTML]="sharedConstant[businessUnit].empOrParticipantsLastName"></label>
              </p-float-label>
            </div>
            <p class="sdps-text-right sdps-m-around_none sdps-text-small line-height-nml" *ngIf="reportDetails.get('employeeLastName').value && reportDetails.get('employeeLastName').value.length > showTextboxCharLimit">{{getShellConstant.reports.characterLimit}}
              <span class="character-limit">{{reportDetails.get('employeeLastName').value.length}} /{{getCommConst.charLimitValues.thirtyMaxLimit}}
              </span>
            </p>
          </div>

        </div>

        <div class="sdps-row sdps-p-top_large select-report-type">
          <div class="col-3 sdps-p-left_none" *ngIf="!snapshotSelected">
            <div class="report-textbox-border" [ngClass]="{'invalidField': (reportDetails.get('accountHolderLastName').value && reportDetails.get('accountHolderLastName').invalid)}">
              <p-float-label variant="in">
                <input type="text" id="accountHolderLastName" *ngIf="businessUnit === sharedConstant.rbsBUText" name="accountHolderLastName" [maxLength]="30" formControlName="accountHolderLastName" emsNamePatternCheck
                       emsCharacterLimit (emsCharacterLimitCheck)="showTextboxCharLimit = $event" [charMaxLimit]="getCommConst.charLimitValues.thirtyMaxLimit"
                       pInputText/>
                <input type="text" id="accountHolderLastName" *ngIf="businessUnit !== sharedConstant.rbsBUText" name="accountHolderLastName" [maxLength]="30" formControlName="accountHolderLastName"
                       emsCharacterLimit (emsCharacterLimitCheck)="showTextboxCharLimit = $event" [charMaxLimit]="getCommConst.charLimitValues.thirtyMaxLimit" [uppercaseRequired]="true"
                       pInputText/>
                <label for="accountHolderLastName">{{getShellConstant.reports.presetReports.accountHolderLastName}}</label>
              </p-float-label>
            </div>
            <p class="sdps-text-right sdps-m-around_none sdps-text-small line-height-nml" *ngIf="reportDetails.get('accountHolderLastName').value && reportDetails.get('accountHolderLastName').value.length > showTextboxCharLimit">{{getShellConstant.reports.characterLimit}}
              <span class="character-limit">{{reportDetails.get('accountHolderLastName').value.length}} /{{getCommConst.charLimitValues.thirtyMaxLimit}}
              </span>
            </p>
          </div>
          <div class="col-3 sdps-p-left_none">
            <div class="sdps-p-left_none sdps-dropdown--lightGrey emtr-dropdown employee-dropdown dropdown-width employee-association-dropdown report-groupname">
              <p-floatlabel variant="in">
                <ems-lazy-load-dropdown [id]="'empGroupName'" [name]="'empGroupName'" [orgID]="orgID" [dropdownName]="'groupName'"
                  [businessUnit]="businessUnit"
                  [resetToken]="groupDropdownResetToken"
                  [isAllOptionDisabled]="snapshotSelected"
                  [autoSelectFirstOption]="true"
                  [keepEmptyWhenNoData]="true"
                  [isDropdownDisabled]="noGroupsAvailable"
                  [ariaLabel]="reportService.businessUnit === getShellConstant.rbsBUText ? getShellConstant.reports.presetReports.enterPlanName : getShellConstant.reports.presetReports.enterGroupName"
                  (ngModelGroupChange)="groupNameUpdated($event)"
                  (groupsAvailable)="onGroupsAvailable($event)"></ems-lazy-load-dropdown>
                <label for="empGroupName">{{reportService.businessUnit === getShellConstant.rbsBUText ? getShellConstant.reports.presetReports.enterPlanName : getShellConstant.reports.presetReports.enterGroupName}}</label>
              </p-floatlabel>
            </div>
          </div>
        </div>
      </div>
    </form>

    <ems-step-wizard-buttons [showCancelBtn]="true" (closeBtn)="cancelReport()" [showRunReportBtn]="true" [disableBtn]="snapshotSelected ? parent.schErrorMsg.length > 0 || disableRunButton : reportDetails.invalid || parent.schErrorMsg.length > 0 || endDateLessThanStartDate || dateError || disableRunButton"
      (runReport)="runReports()"></ems-step-wizard-buttons>
  </div>
</div>
